// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Doab","placeholder":"_3ci-J"};